import { FormTemplateTypesEnum } from '@common/enums';
import { IOption } from './common';

export interface IFixerElement {
  type: FormTemplateTypesEnum;
  label: string;
  value: string;
  options?: IOption[];
}
